import { render } from "./AdminView.vue?vue&type=template&id=dda91788&scoped=true"
import script from "./AdminView.vue?vue&type=script&lang=js"
export * from "./AdminView.vue?vue&type=script&lang=js"

import "./AdminView.vue?vue&type=style&index=0&id=dda91788&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda91788"]])

export default __exports__